import { Component, ViewChild } from '@angular/core';
import { CardlinkComponent } from '../cardlink/cardlink.component';

@Component({
  selector: 'app-eurobank',
  templateUrl: './eurobank.component.html',
  styleUrls: ['./eurobank.component.scss'],
})
export class EurobankComponent {
  @ViewChild('cardlinkComponent') cardlinkComponent: CardlinkComponent;
  requestJSON: any;

  submitForm(requestJSON: any) {
    this.requestJSON = requestJSON;
    if (this.cardlinkComponent) {
      this.cardlinkComponent.submitForm(requestJSON);
    }
  }
}
